import Countdown from 'react-countdown';
import React, {
  useState,
  useRef,
  useContext,
  Redirect,
  useEffect,
} from 'react';

export default function TimeRemaining(props) {
  const dateUploaded = props.dateUploaded;
  console.log('dateUploaded: ' + dateUploaded);
  const timeRemaining =
    Date.now() + (86400000 - (Date.now() - new Date(dateUploaded).getTime()));
  console.log('timeRemaining: ' + timeRemaining);
  //<TimeRemaining dateUploaded = {item.dateUploaded}/>
  return <Countdown date={new Date(timeRemaining)} />;
}
